// extracted by mini-css-extract-plugin
export default {"content":"container_content__155Ch","fullView":"container_fullView__FDzum","shimmer":"container_shimmer__6Dcf2"};